<template>
    <div class="visual">
        <transition-group name="slide" mode="in-out" tag="ul">
        <template v-for="(item, index) in visuals">
        <li :key="item.title"
            :class="['visual__item', 'is-' + item.title]"
            v-show="index === counter">
            <div class="content">
                <div :class="['content__icon', 'icon' + (index + 1)]"></div>
                <p class="content__text" v-html="$t(item.desc)"></p>
                <router-link class="content__link is-lato"
                    :to="'/business#' + item.title"
                    @click.native="$store.commit('setBusinessType', index + 1)">VIEW MORE</router-link>
            </div>
            <div class="background" v-if="$resize && $mq.above(1024)">
                <video autoplay loop muted preload="auto" playsinline class="main-video">
                    <source :src="item.path" type="video/mp4">
                </video>
            </div>
            <div class="background" v-else-if="$resize && $mq.above(320)">
                <video autoplay loop muted preload="auto" playsinline
                class="main-video is-mobile-video">
                    <source :src="item.mPath" type="video/mp4" >
                </video>
            </div>
        </li>
        </template>
        </transition-group>
        <ul :class="['nav', 'is-active-' + counter]">
            <li v-for="(item, index) in navs" :key="item" @click="goTo(index)" class="nav__item">
                <p class="text is-lato">
                    <span class="title">{{ item }}</span>
                    <span class="number">0{{ index + 1 }}</span>
                </p>
                <div class="background"></div>
            </li>
        </ul>
        <div v-scroll-to="'#content'" class="scroll-down"><span class="is-lato">SCROLL DOWN</span></div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            visuals: [
                {
                    title: 'platform',
                    desc: 'main.visual.desc01',
                    path: require('../../assets/video/main-visual-01.mp4'),
                    mPath: require('../../assets/video/main-visual-01-m.mp4')
                }, {
                    title: 'logistics',
                    desc: 'main.visual.desc02',
                    path: require('../../assets/video/main-visual-02.mp4'),
                    mPath: require('../../assets/video/main-visual-02-m.mp4')
                }, {
                    title: 'fulfillment',
                    desc: 'main.visual.desc03',
                    path: require('../../assets/video/main-visual-03.mp4'),
                    mPath: require('../../assets/video/main-visual-03-m.mp4')
                }, {
                    title: 'contactcenter',
                    desc: 'main.visual.desc04',
                    path: require('../../assets/video/main-visual-04.mp4'),
                    mPath: require('../../assets/video/main-visual-04-m.mp4')
                }
            ],
            navs: [
                'PLATFORM',
                'LOGISTICS',
                'FULFILLMENT',
                'CONTACT CENTER'
            ],
            counter: 0,
            stop: false,
            loop: null
        }
    },
    methods: {
        addCounter: function () {
            this.counter++
            if (this.counter > this.visuals.length - 1) this.counter = 0
        },
        startLoop: function () {
            this.loop = setInterval(this.addCounter, 4000)
        },
        stopLoop: function () {
            clearInterval(this.loop)
            this.looop = null
        },
        goTo: function (n) {
            this.stopLoop()
            this.counter = n
            this.startLoop()
        },
        videoSize: function () {
            var video = '' || document.getElementsByClassName('is-mobile-video')
            var cWidth = document.documentElement.clientWidth
            var cHeight = document.documentElement.clientHeight
            if (cWidth / cHeight > 0.75) {
                Array.prototype.forEach.call(video, function (el) {
                    el.style.width = '100vw'
                    el.style.height = ''
                })
            } else {
                Array.prototype.forEach.call(video, function (el) {
                    el.style.width = ''
                    el.style.height = '100vh'
                })
            }
        },
        setFirstFrame: function () {
            var video = '' || document.getElementsByClassName('main-video')
            video[this.counter].currentTime = 0
            video[this.counter].play()
        }
    },
    watch: {
        counter: function (val, oldVal) {
            this.setFirstFrame()
        }
    },
    mounted: function () {
        this.startLoop()
        this.videoSize()
    },
    updated: function () {
        this.videoSize()
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes scroll-down {
    0% {opacity: 0; transform: translate(-50%, -60px)}
    100% {opacity: 1; transform: translate(-50%, 0)}
}
.visual {
    position: relative;
    width: 100%;
    height: 100vh;
    // height: 100%;
    // &::before {
    //     content: '';
    //     display: block;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     z-index: 5;
    //     width: 100%;
    //     height: 360px;
    //     opacity: 0.75;
    //     background: url(../../assets/image/background/main-gradient.png) no-repeat;
    //     background-size: 100% 360px;
    //     background-position: top center;
    // }
    .scroll-down {
        display: none;
        position: absolute;
        bottom: -40px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        animation: scroll-down 1000ms backwards;
        span {
            position: relative;
            color: #fff;
            font-weight: 700;
            font-size: 12px;
            line-height: 12px;
            &::after {
                content: '';
                display: block;
                margin: 10px auto 0;
                width: 1px;
                height: 40px;
                background: #fff;
                opacity: 0.5;
            }
        }
        &::after {
            content: '';
            display: block;
            margin: 0 auto;
            width: 1px;
            height: 40px;
            background: #e0e0e0;
        }

    }
    &__item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        @keyframes visible {
            0% {opacity: 0; transform: translateY(15px);}
            100% {opacity: 1; transform: translateY(0px);}
        }
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 360px;
            opacity: 0.75;
            background: url(../../assets/image/background/main-gradient.png) no-repeat;
            background-size: 100% 360px;
            background-position: top center;
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 2;
            width: 100%;
            padding-left: 150px;
            transform: translate(-50%, -50%);
            &__icon {
                width: 100px;
                height: 80px;
                animation: visible 1000ms ease 400ms backwards;

                @for $i from 1 to 5 {
                    &.icon#{$i} {
                        background: url(../../assets/image/main/icon0#{$i}.png) no-repeat top left;
                        // background-size: auto 100%;
                    }
                }
            }
            &__text {
                margin-top: 10px;
                color: #fff;
                font-weight: 200;
                font-size: 44px;
                line-height: 54px;
                letter-spacing: -1px;
                animation: visible 1000ms ease 600ms backwards;
            }
            &__link {
                margin-top: 50px;
                width: 206px;
                height: 54px;
                background: url(../../assets/image/main/button.svg) no-repeat center;
                background-size: 100% auto;
                color: #fff;
                font-size: 14px;
                line-height: 14px;
                line-height: 54px;
                text-align: center;
                animation: visible 1000ms ease 800ms backwards;

                &:hover {
                    background: url(../../assets/image/main/button-hover.svg) no-repeat center;
                    background-size: 100% auto;
                }
            }
        }
        @include over-desktop {
            .background {
                overflow: hidden;
                position: absolute;
                top: 0;
                bottom: 0;
                width: 100%;
                // height: 100vh;
                // height: calc(var(--vh, 1vh) * 100);
                height: 100%;
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba($color: #000, $alpha: 0.2)
                }
            }
            .background video {
                position: absolute;
                top: 50%;
                left: 50%;
                width: auto;
                height: auto;
                min-width: 100%;
                min-height: 100%;
                transform: translate(-50%,-50%);
            }
        }
    }
    @media (min-width: 1500px) {
        .content {
            width: 1200px;
            padding-left: 0;
        }
    }
    @include desktop-small {
        &__item {
            .content {
                padding-left: 150px;
                &__text {
                    font-size: 34px;
                    line-height: 42px;
                }
            }
        }
    }
    @include under-tablet {
        &::before {
            height: 30vh;
            background-size: 100% 100%;
            background-origin: bottom center;
        }
        .scroll-down {
            bottom: -3vh;
            transform: translateX(-50%);
            cursor: pointer;
            animation: scroll-down 1000ms backwards;
            span {
                font-size: 3.4vw;
                line-height: 3.4vw;
                &::after {
                    height: 3vh;
                    margin-top: 2vw;
                }
            }
            &::after {
                height: 3vh;
            }
        }
        &__item {
            .content {
                padding-left: 28px;
                &__icon {
                    width: 18vw;
                    height: 12vw;

                    @for $i from 1 to 5 {
                        &.icon#{$i} {
                            background: url(../../assets/image/main/icon0#{$i}.svg) no-repeat top left;
                            background-size: auto 100%;
                        }
                    }
                }
                &__text {
                    margin-top: 4vw;
                    font-size: 5.2vw;
                    letter-spacing: -0.4vw;
                    line-height: 7.2vw;
                }
                &__link {
                    margin-top: 6vw;
                    width: 34vw;
                    height: 10vw;
                    font-size: 2.8vw;
                    line-height: 10vw;
                    &:hover {
                        width: 34vw;
                        height: 10vw;
                        background: url(../../assets/image/main/button-hover.svg) no-repeat center;
                        background-size: 100% auto;
                    }
                }
            }
            .background {
                overflow: hidden;
                position: absolute;
                top: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba($color: #000, $alpha: 0.35)
                }
            }
            .background video {
                position: absolute;
                top: 50%;
                left: 50%;
                // width: 100vw;
                // height: 100vh;
                min-width: 100%;
                min-height: 100%;
                // max-width: 100vw;
                // max-height: 100vh;
                transform: translate(-50%,-50%);
            }
        }
    }
    @include mobile {
        &__item {
            .content {
                padding-left: 20px;
                &__icon {
                    width: 20vw;
                    height: 14vw;
                }
                &__link {
                    margin-top: 6vw;
                    width: 40vw;
                    height: 12vw;
                    font-size: 3.2vw;
                    line-height: 12vw;
                    &:hover {
                        width: 40vw;
                        height: 12vw;
                        background: url(../../assets/image/main/button-hover.svg) no-repeat center;
                        background-size: 100% auto;
                    }
                }
            }
        }
    }
}
.nav {
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 10;
    transform: translateY(-50%);

    &__item {
        display: block;
        position: relative;
        width: 280px;
        height: 52px;
        margin-bottom: 6px;
        background: rgba(0, 0, 0, 0.3);
        cursor: pointer;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: -16px;
            width: 0;
            height: 0;
            border-top: 26px solid transparent;
            border-right: 16px solid rgba(0, 0, 0, 0.3);
            border-bottom: 26px solid transparent;
        }

        .text {
            position: absolute;
            top: 50%;
            z-index: 1;
            width: 100%;
            padding-left: 25px;
            color: rgba(255, 255, 255, 0.5);
            font-weight: 700;
            font-size: 13px;
            line-height: 13px;
            transform: translateY(-50%);

            .number {
                position: absolute;
                right: 70px;

                &::before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 62%;
                    left: -94px;
                    width: 87px;
                    height: 8px;
                    background: url(../../assets/image/main/nav-shape-gray.svg) no-repeat left;
                    transform: translateY(-50%);
                }
            }
        }
        &:nth-child(3) {
            .text .number::before {
                left: -66px;
                width: 57px;
            }
        }
        &:nth-child(4) {
            .text .number::before {
                left: -38px;
                width: 29px;
            }
        }
        .background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #fff;
            opacity: 0;
            transition: opacity 250ms;

            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: -16px;
                width: 0;
                height: 0;
                border-top: 26px solid transparent;
                border-right: 16px solid #fff;
                border-bottom: 26px solid transparent;
            }
        }
    }
    @for $i from 0 to 4 {
        &.is-active-#{$i} {
            .nav__item:nth-child(#{$i + 1}) {
                .text {
                    color: #555;
                    .number::before {
                        background: url(../../assets/image/main/nav-shape.svg) no-repeat left;
                    }
                }
                .background {
                    opacity: 1;
                }
            }
        }
    }
    @include under-tablet {
        $tri-height: 6px;
        $tri-width: 4px;
        right: 28px;
        &__item {
            width: 6px;
            height: #{$tri-height * 2};
            margin-top: 1vw;
            &::before {
                left: -#{$tri-width};
                border-top: $tri-height solid transparent;
                border-right: $tri-width solid rgba(0, 0, 0, 0.3);
                border-bottom: $tri-height solid transparent;
            }
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                right: -#{$tri-width};
                width: 0;
                height: 0;
                border-top: $tri-height solid transparent;
                border-left: $tri-width solid rgba(0, 0, 0, 0.3);
                border-bottom: $tri-height solid transparent;
            }
            .text {
                display: none;
            }
            .background {
                position: relative;
                z-index: 1;
                &::before {
                    left: -#{$tri-width};
                    border-top: $tri-height solid transparent;
                    border-right: $tri-width solid #fff;
                    border-bottom: $tri-height solid transparent;
                }
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    right: -#{$tri-width};
                    width: 0;
                    height: 0;
                    border-top: $tri-height solid transparent;
                    border-left: $tri-width solid #fff;
                    border-bottom: $tri-height solid transparent;
                }
            }
        }
    }
    @include mobile {
        right: 20px;
        &__item {
            margin-top: 1.4vw;
            transform: scale(0.8);
        }
    }
}
.slide-enter {
    opacity: 0;
}
.slide-enter-to {
    opacity: 1;
}
.slide-enter-active {
    transition: opacity 250ms;
}
.slide-leave {
    opacity: 1;
}
.slide-leave-to {
    opacity: 0;
}
.slide-leave-active {
    transition: opacity 250ms 250ms;
    z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Visual.vue